module.exports = __webpack_public_path__ + "img/ANTENNA 2 PURPLE.77823d5.svg";